import {Component, Input} from "@angular/core";
import {BaseComponent} from "../../../base.component";
import {LoggerService} from "../../../common/logger.service";
import {UserService} from "../../../common/user.service";

@Component({
    selector: 'ssd-sessions',
    templateUrl: './ssd-session.component.html',
    styleUrls: ['./ssd-session.component.scss', '../shop-session-dashboard-tab.scss'],
    standalone: false
})
export class SsdSessionComponent extends BaseComponent {

    @Input() shopSessions: any;
    showDetailsShopSessionId: number;

    constructor(
        loggerService: LoggerService,
        userService: UserService,
    ) {
        super(userService, loggerService);
    }

    detailsClicked(detailShopSessionId: number) {
        if(detailShopSessionId != this.showDetailsShopSessionId) {
            this.showDetailsShopSessionId = detailShopSessionId;
        } else {
            this.showDetailsShopSessionId = 0;
        }
    }
}
